import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CARD_VIEW } from 'site-modules/shared/constants/lead-form/lead-form-params';
import { CARD_LIST_COMPONENT_MAP } from 'site-modules/shared/constants/lead-form/lead-form-templates';
import { getLeadUid, getCardView } from 'site-modules/shared/components/lead-form/utils/utils';
import { Checkbox } from 'site-modules/shared/components/checkbox/checkbox';

import './card.scss';

export class Card extends Component {
  static propTypes = {
    classes: PropTypes.string,
    leadTarget: PropTypes.shape({
      inventory: PropTypes.shape({}),
      dealer: PropTypes.shape({}),
      leadAttributes: PropTypes.shape({
        primary: PropTypes.bool.isRequired,
        selected: PropTypes.bool.isRequired,
        distance: PropTypes.number,
      }).isRequired,
    }).isRequired,
    onChangeLeadSelection: PropTypes.func.isRequired,
    selectedLeadIds: PropTypes.shape({}).isRequired,
    multi: PropTypes.bool.isRequired,
    priceStrikethrough: PropTypes.bool,
    showInventoryMakeStockImage: PropTypes.bool,
    showDealerMakeStockImage: PropTypes.bool,
    showBestDealPrice: PropTypes.bool,
    showVehicleMileage: PropTypes.bool,
    showNationwideDeliveryBadge: PropTypes.bool,
    enableSelection: PropTypes.bool,
    zipCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stateCode: PropTypes.string,
    cardView: PropTypes.string,
    slot: PropTypes.number.isRequired,
    inventoryText: PropTypes.string,
    checkboxContainerClassName: PropTypes.string,
    checkBoxCustomLabelClassName: PropTypes.string,
  };

  static defaultProps = {
    classes: '',
    priceStrikethrough: false,
    showInventoryMakeStockImage: false,
    showDealerMakeStockImage: false,
    showBestDealPrice: false,
    showVehicleMileage: false,
    showNationwideDeliveryBadge: false,
    enableSelection: true,
    zipCode: '',
    stateCode: '',
    cardView: CARD_VIEW.DEFAULT,
    inventoryText: '',
    checkboxContainerClassName: 'left-pos pe-1 me-1',
    checkBoxCustomLabelClassName: null,
  };

  onKeyDown = event => {
    if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
      event.preventDefault();
      this.onSelectionChange();
    }
  };

  onSelectionChange = () => {
    const { leadTarget, slot, multi, enableSelection } = this.props;
    const { primary } = leadTarget.leadAttributes;
    if (multi && !primary && enableSelection) {
      this.props.onChangeLeadSelection(getLeadUid(leadTarget), slot);
    }
  };

  getCardViewComponent = leadTarget => {
    const { cardView } = this.props;
    if (CARD_VIEW.DEFAULT === cardView) {
      const card = getCardView(leadTarget);
      return CARD_LIST_COMPONENT_MAP[card];
    }
    return CARD_LIST_COMPONENT_MAP[cardView];
  };

  render() {
    const {
      selectedLeadIds,
      multi,
      reverseCardView,
      leadTarget,
      cardView,
      classes,
      enableSelection,
      checkboxContainerClassName,
      checkBoxCustomLabelClassName,
      ...props
    } = this.props;

    const CardComponent = this.getCardViewComponent(leadTarget);
    const uid = `${getLeadUid(leadTarget)}`;
    const selected = selectedLeadIds[uid];
    const isSelectionDisabled = !enableSelection;
    const tabIndex = isSelectionDisabled ? null : 0;
    return (
      <div
        className={classnames('ulf-inventory-card', classes)}
        onClick={isSelectionDisabled ? null : this.onSelectionChange}
        onKeyDown={isSelectionDisabled ? null : this.onKeyDown}
        {...(!isSelectionDisabled ? { role: 'checkbox' } : {})}
        aria-checked={isSelectionDisabled ? null : !!selected}
        tabIndex={tabIndex}
      >
        {reverseCardView && multi && enableSelection && (
          <Checkbox
            id={uid}
            checked={!!selected}
            readOnly
            tabIndex={-1}
            containerClassName={checkboxContainerClassName}
            customLabelClassName={checkBoxCustomLabelClassName}
            aria-hidden
          />
        )}
        <CardComponent leadTarget={leadTarget} {...props} />
        {!reverseCardView && multi && enableSelection && (
          <Checkbox id={uid} checked={!!selected} readOnly tabIndex={-1} aria-hidden />
        )}
      </div>
    );
  }
}
